<template>
  <div v-if="visible">
    <div style="width: fit-content">
      <div class="section">
        <el-form ref="basicForm" style="display: flex;flex-direction: column" :inline="true" label-position="left" label-width="90px">
          <div>
            <el-checkbox v-model="job.mblOnly" no="4" :disabled="readonly" class="checkbox" @change="isMblOnlyChange()">{{ $t('SeaExport.DirectBusiness') }}</el-checkbox>
            <el-checkbox v-model="job.trans" no="5" :disabled="readonly" class="checkbox">{{ $t('SeaImport.ChangeOrders') }}</el-checkbox>
            <el-checkbox v-model="job.warehousing" no="6" :disabled="readonly" class="checkbox" @change="chkWarehousing_changeHandler">{{ $t('SeaExport.Storage') }}</el-checkbox>
            <el-checkbox v-model="job.parts" no="7" :disabled="readonly" class="checkbox">{{ $t('SeaExport.Devanning') }}</el-checkbox>
            <el-checkbox v-model="job.landTransportation" no="8" :disabled="readonly" class="checkbox">{{ $t('SeaExport.DeliveryToDoor') }}</el-checkbox>
            <el-checkbox v-model="job.customs" no="9" :disabled="readonly" class="checkbox" @change="chkCustoms_changeHandler">{{ $t('SeaExport.CustomsDeclaration') }}</el-checkbox>
            <el-checkbox v-model="job.insure" :disabled="readonly" class="checkbox">{{ $t('SeaExport.InsureInfo') }} </el-checkbox>
            <el-checkbox v-model="job.signMBL" no="10" :disabled="readonly" class="checkbox" @change="isMBLChange">MB/L</el-checkbox>
            <el-checkbox v-model="job.signHBL" no="11" :disabled="readonly || (!readonly && job.mblOnly)" class="checkbox" @change="isHBLChange">HB/L</el-checkbox>
            <el-checkbox v-model="job.booking" no="12" :disabled="readonly" class="checkbox">{{ $t('SeaExport.Booking') }}</el-checkbox>
            <el-checkbox v-model="job.itmService" no="13" :disabled="readonly" class="checkbox">{{ $t('SeaExport.ForeignTrade') }}</el-checkbox>
            <el-checkbox v-model="job.international" no="14" :disabled="readonly" class="checkbox">{{ $t('SeaExport.InternationalTransport') }}</el-checkbox>
            <el-checkbox v-model="job.usCustomsClearance" no="15" :disabled="readonly" class="checkbox">{{ $t('queryJob.UsCustomsClearance') }}</el-checkbox>
            <el-checkbox v-if="!job.lclMasterUuid" v-model="job.importManifest" no="15.5" :disabled="readonly">{{ $t('SeaImport.ImportManifest') }}</el-checkbox>
            <el-button
              v-permission="['button_insurance_toInsure']"
              no="16"
              :disabled="isEdit || !!previewConfig"
              type="primary"
              style="margin-left: 10px"
              @click="pm.toInsure()"
            >{{ $t('SeaExport.Insure') }}</el-button>
            <span v-if="!!templateName" class="blue" style="float: right;margin-right: 30px;line-height: 28px;padding: 0 5px;white-space: nowrap;">{{ $t('CargoMsg.Cargo_SopTemplate') }}: {{ templateName }}</span>
          </div>
        </el-form>
      </div>
      <basic-tab-UICustom-layout :element-blocks="elementBlocks">
        <el-form-item v-if="elementDict.jobNo.slaveVisible" slot="jobNo">
          <line-label slot="label" :class="elementDict.jobNo.isRequire ? 'blue' : ''" :label="elementDict.jobNo.label" />
          <el-input v-model="job.jobNo" no="1" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.masterJobNo.slaveVisible" slot="masterJobNo">
          <line-label slot="label" :class="elementDict.masterJobNo.isRequire ? 'blue' : ''" :label="elementDict.masterJobNo.label" />
          <el-input v-model="job.masterJobNo" no="2" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.customerRefNo.slaveVisible" slot="customerRefNo">
          <line-label slot="label" :class="elementDict.customerRefNo.isRequire ? 'blue' : ''" :label="elementDict.customerRefNo.label" />
          <cargo-input v-model="job.customerRefNo" no="3" :disabled="readonly" :auto-uppercase="isUppercase" :trim="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.customerId.slaveVisible" slot="customerId">
          <line-label slot="label" :class="elementDict.customerId.isRequire ? 'blue' : ''" :label="elementDict.customerId.label" />
          <div style="display: flex;align-items: center">
            <el-tooltip
              v-show="sopImageA"
              no="17"
              :content="$t('SeaExport.SOPReceiver')"
              placement="right-end"
            >
              <div>
                <img
                  :src="sopPic"
                  width="18"
                  height="28"
                  style="padding: 5px 0;cursor: pointer"
                  @click="pm.sopChangeCustomerIdHandler()"
                >
              </div>
            </el-tooltip>
            <el-tooltip v-show="creditTip.showWarningImageA" :content="creditTip.warningImageATip" placement="right-end">
              <i
                class="el-icon-warning red"
                style="cursor: pointer"
              />
            </el-tooltip>
            <cargo-sales-company-select
              no="18"
              class="shipper-selector"
              popper-class="shipper-selector-popper"
              :method-params="{customer:true,active:true,companyLob:'seaImport'}"
              :check-credit="true"
              :default-value="job.customerId||''"
              :disabled="!customerEnabled"
              :job="job"
              style="flex: 1;"
              @parentCallBack="p=>{pm.customerIdEnterHandler(p);pm.clearPoNo()}"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.customerRemarks.slaveVisible" slot="customerRemarks">
          <line-label slot="label" :class="elementDict.customerRemarks.isRequire ? 'blue' : ''" :label="elementDict.customerRemarks.label" />
          <el-select
            v-model="job.customerRemarks"
            no="19"
            :disabled="readonly"
            :clearable="true"
            :allow-create="true"
            filterable
            @blur="selectCustomerRemarksBlur"
          >
            <el-option
              v-for="(item,index) in customerRemarks"
              :key="index"
              :label="item.lable"
              :value="item.lable"
            />
          </el-select>
        </el-form-item>
        <template v-if="isZY">
          <el-form-item slot="saleProductCode">
            <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_AllowSaleProduct"
              filterable
              no="allowSaleProduct"
              :disabled="readonly"
              clearable
              :data-filter-function="p => p.statusEnabled && p.seaImportEnabled"
              :default-value="this.job.saleProductCode || ''"
              @parentCallBack="p => {this.job.saleProductCode = p.value}"
            />
          </el-form-item>
          <el-form-item slot="fullOrInside">
            <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
            <cargo-advance-select
              :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
              no="fullOrInside"
              :disabled="readonly"
              clearable
              :default-value="this.job.fullOrInside || ''"
              @parentCallBack="p => {this.job.fullOrInside = p.value}"
            />
          </el-form-item>
        </template>
        <el-form-item v-if="elementDict.customerProperty.slaveVisible" slot="customerProperty">
          <line-label slot="label" :class="elementDict.customerProperty.isRequire ? 'blue' : ''" :label="elementDict.customerProperty.label" />
          <el-tooltip :content="customerTip" placement="bottom">
            <span
              v-show="customerLevel.customerName"
              style="color:#FD9A14"
            >LV{{ customerLevel.level }}</span>
            <span
              v-show="customerLevel.customerName"
              style="color:#D3A73B"
            >&nbsp;{{ customerLevel.customerName }}</span>
            <span v-show="contractStatusLabel" class="red">&nbsp;({{ contractStatusLabel }})</span>
            <span v-show="advancePaymentLabel" style="color:brown">&nbsp;({{ advancePaymentLabel }})</span>
            <span v-show="stampPictureView.businessDocuments.length > 0" @click="stampPictureView.visible = true">
              <img :title="$t('Message.BookingSeal')" :src="stampIcon" height="14" style="text-align: right;">
            </span>
          </el-tooltip>
        </el-form-item>
        <el-form-item v-if="elementDict.customerContact.slaveVisible" slot="customerContact">
          <line-label slot="label" :class="elementDict.customerContact.isRequire ? 'blue' : ''" :label="elementDict.customerContact.label" />
          <div style="display: flex;justify-content: space-between">
            <el-select v-model="job.customerContact" no="20" :disabled="readonly" style="flex: 1" filterable :allow-create="true" @change="tfLinkmanHandler">
              <el-option
                v-for="(item,index) in contactList"
                :key="index"
                :label="item.contactPerson"
                :value="item.contactPerson"
              />
            </el-select>
            <el-link v-show="!isShowContactPersonDetail" no="21" @click="showContactsInfoDialog=true">{{ $t('SeaExport.Detail') }}</el-link>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.contactTelephone.slaveVisible" slot="contactTelephone">
          <line-label slot="label" :class="elementDict.contactTelephone.isRequire ? 'blue' : ''" :label="elementDict.contactTelephone.label" />
          <el-input v-model="job.contactTelephone" no="22" :disabled="readonly" />
        </el-form-item>
        <el-form-item v-if="elementDict.contactFax.slaveVisible" slot="contactFax">
          <line-label slot="label" :class="elementDict.contactFax.isRequire ? 'blue' : ''" :label="elementDict.contactFax.label" />
          <el-input v-model="job.contactFax" no="23" :disabled="readonly" />
        </el-form-item>
        <el-form-item v-if="elementDict.cargoSource.slaveVisible" slot="cargoSource">
          <line-label slot="label" :class="elementDict.cargoSource.isRequire ? 'blue' : ''" :label="elementDict.cargoSource.label" />
          <el-select
            v-model="job.cargoSource"
            no="24"
            :disabled="readonly || isCrossTenantSEToSI"
            :placeholder="$t('SeaExport.PleaseSelect')"
            size="mini"
            @change="val=>{
              pm.cargoSourceChange(val)
              OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(view)
            }"
          >
            <el-option
              v-for="(item,index) in CARGO_SOURCES"
              :key="index"
              :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>&nbsp;
        </el-form-item>
        <el-form-item v-if="elementDict.customJobType.slaveVisible" slot="customJobType">
          <line-label slot="label" :class="elementDict.customJobType.isRequire ? 'blue' : ''" :label="elementDict.customJobType.label" />
          <cargo-advance-select
            no="25"
            filterable
            :clearable="true"
            :placeholder="$t('SeaExport.PleaseSelect')"
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_CutomJobType"
            :default-value="job.customJobType "
            :static-options="customJobTypeList"
            :method-params="{type:job.lob}"
            @parentCallBack="p=>{job.customJobType=p.value;onCustomJobTypeChange(p)}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.secondaryCustomJobType.slaveVisible && job.customJobType && secondaryCustomJobTypeList.length > 0" slot="secondaryCustomJobType">
          <line-label slot="label" :class="elementDict.secondaryCustomJobType.isRequire ? 'blue' : ''" :label="elementDict.secondaryCustomJobType.label" />
          <cargo-advance-select
            ref="secondaryCustomJobType"
            no="secondaryCustomJobType"
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_CutomJobType"
            filterable
            :cache="false"
            :default-value="job.secondaryCustomJobType"
            :tag-name="isZh?'name':'englishName'"
            :static-options="secondaryCustomJobTypeList"
            @parentCallBack="p=>{job.secondaryCustomJobType=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.salesChannel.slaveVisible" slot="salesChannel">
          <line-label slot="label" :class="elementDict.salesChannel.isRequire ? 'blue' : ''" :label="elementDict.salesChannel.label" />
          <el-input v-model="job.salesChannel" no="26" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.channelNo.slaveVisible && showChannelNo" slot="channelNo">
          <line-label slot="label" :class="elementDict.channelNo.isRequire ? 'blue' : ''" :label="elementDict.channelNo.label" />
          <el-input no="27" :value="job.channelNo" :disabled="true" />
        </el-form-item>
        <el-form-item v-show="elementDict.designationAgent.slaveVisible && visibleDesignationAgent" slot="designationAgent">
          <line-label slot="label" :class="elementDict.designationAgent.isRequire ? 'blue' : ''" :label="elementDict.designationAgent.label" />
          <div style="display: flex;align-items: center">
            <el-tooltip
              v-show="sopImageC"
              no="28"
              :content="$t('SeaExport.SOPReceiver')"
              placement="right-end"
            >
              <div>
                <img
                  :class="job.designationAgent&&readonly?'':'not-click'"
                  :src="sopPic"
                  width="18"
                  height="28"
                  style="padding: 5px 0;cursor: pointer"
                  @click="pm.sopChangeBookingAgentHandler()"
                >
              </div>
            </el-tooltip>
            <el-tooltip v-show="creditTip.showWarningImageC" :content="creditTip.warningImageCTip" placement="right-end">
              <i
                class="el-icon-warning red"
                style="cursor: pointer"
              />
            </el-tooltip>
            <cargo-company-select
              ref="designationAgent"
              no="29"
              :disabled="!controllerEnable.txtDesignationAgent"
              :method-params="{designationAgent:true,active:false}"
              :check-credit="true"
              :job="job"
              :default-value="job.designationAgent||''"
              tag-name="englishName"
              style="width: 100%"
              @change="p=>{pm.designationAgentChangeHandler(p)}"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.trustFromJob.slaveVisible && (!showChannelNo || isCrossTenantSEToSI)" slot="trustFromJob">
          <line-label slot="label" :class="elementDict.trustFromJob.isRequire ? 'blue' : ''" :label="elementDict.trustFromJob.label" />
          <el-input no="30" :value="job.trustFromJob" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.relatedJob && elementDict.relatedJob.slaveVisible && (!showChannelNo || isCrossTenantSEToSI)" slot="relatedJob">
          <line-label slot="label" :class="elementDict.relatedJob.isRequire ? 'blue' : ''" :label="elementDict.relatedJob.label" />
          <el-input no="relatedJob" :value="job.relatedJob" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.destinationAgent.slaveVisible" slot="destinationAgent">
          <line-label slot="label" :class="elementDict.destinationAgent.isRequire ? 'blue' : ''" :label="elementDict.destinationAgent.label" />
          <div style="display: flex;align-items: center">
            <el-tooltip
              v-show="sopImageB"
              no="31"
              :content="$t('SeaExport.SOPReceiver')"
              placement="right-end"
            >
              <div>
                <img
                  :src="sopPic"
                  width="18"
                  height="28"
                  style="padding: 5px 0;cursor: pointer"
                  @click="pm.sopChangeHandler()"
                >
              </div>
            </el-tooltip>
            <el-tooltip v-show="creditTip.showWarningImageB" :content="creditTip.warningImageBTip" placement="right-end">
              <i
                class="el-icon-warning red"
                style="cursor: pointer"
              />
            </el-tooltip>
            <cargo-company-select
              no="32"
              :disabled="readonly || isCrossTenantSEToSI"
              :method-params="{overseaAgent:true,active:true}"
              :default-value="job.destinationAgent||''"
              :check-credit="true"
              :job="job"
              tag-name="englishName"
              style="width: 100%"
              @change="p=>{pm.txtDestinationAgentChangeHandler(p)}"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.carrierId.slaveVisible" slot="carrierId">
          <line-label slot="label" :class="elementDict.carrierId.isRequire ? 'blue' : ''" :label="elementDict.carrierId.label" />
          <cargo-company-select
            no="33"
            :disabled="!controllerEnable.txtCarrierId"
            :method-params="{companyLob:'seaImport',seaCmp:true,active:true}"
            :default-value="job.carrierId||''"
            @change="p=>{job.carrierId=p.value;onCarrierIdChange(this.scacList, this.carrierScacEdit)}"
          />
        </el-form-item>
        <!-- 船公司SCAC -->
        <el-form-item v-if="elementDict.carrierScac && elementDict.carrierScac.viewable" slot="carrierScac">
          <line-label slot="label" :class="elementDict.carrierScac.isRequire ? 'blue' : ''" :label="elementDict.carrierScac.label" />
          <cargo-advance-select
            no="carrierScac"
            filterable
            :custom-label="(item)=>`[${item.code}]${item.englishName?item.englishName:item.code}`"
            :filter-tag-names="['code','englishName']"
            :show-custom-label-in-option="true"
            :static-options="scacList"
            tag-value="code"
            :disabled="readonly || !carrierScacEdit || !elementDict.carrierScac.writable"
            :default-value="job.carrierScac||''"
            @parentCallBack="p=>{job.carrierScac = p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.bookingAgent.slaveVisible && bookingAgentVisible" slot="bookingAgent">
          <line-label slot="label" :class="elementDict.bookingAgent.isRequire ? 'blue' : ''" :label="elementDict.bookingAgent.label" />
          <cargo-company-select
            no="34"
            :disabled="!controllerEnable.txtBookingAgent"
            :method-params="{bookingAgent:true,companyLob:'seaImport',active:true}"
            :default-value="job.bookingAgent||''"
            @change="p=>{job.bookingAgent=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.exChangeAgent.slaveVisible" slot="exChangeAgent">
          <line-label slot="label" :class="elementDict.exChangeAgent.isRequire ? 'blue' : ''" :label="elementDict.exChangeAgent.label" />
          <cargo-company-select
            no="130"
            :disabled="readonly"
            :method-params="{bookingAgent:true,companyLob:'seaImport',active:true}"
            :default-value="job.exChangeAgent||''"
            @change="p=>{job.exChangeAgent=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.mbl.slaveVisible" slot="mbl">
          <line-label slot="label" :class="elementDict.mbl.isRequire ? 'blue' : ''" :label="elementDict.mbl.label" />
          <div style="display: flex;">
            <cargo-input v-model="job.mbl" no="35" :disabled="readonly || !pm.lclMasterFlag || isCrossTenantSEToSI" :auto-uppercase="isUppercase" @change="mbl_Change" />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.hbl.slaveVisible" slot="hbl">
          <line-label slot="label" :class="elementDict.hbl.isRequire ? 'blue' : ''" :label="elementDict.hbl.label" />
          <cargo-input v-model="job.hbl" no="36" :disabled="readonly || isCrossTenantSEToSI" :auto-uppercase="isUppercase" @change="updateHBL" />
        </el-form-item>
        <el-form-item v-if="elementDict.customsHbl.slaveVisible" slot="customsHbl">
          <line-label slot="label" :class="elementDict.customsHbl.isRequire ? 'blue' : ''" :label="elementDict.customsHbl.label" />
          <cargo-input v-model="job.customsHbl" no="37" :disabled="readonly" :auto-uppercase="isUppercase" @change="customsHblChange" />
        </el-form-item>
        <el-form-item v-if="elementDict.jobSoNo.slaveVisible" slot="jobSoNo">
          <line-label slot="label" :class="elementDict.jobSoNo.isRequire ? 'blue' : ''" :label="elementDict.jobSoNo.label" />
          <so-no-input v-model="job.jobSoNo" no="38" :disabled="readonly" />
        </el-form-item>
        <el-form-item v-if="elementDict.vessel.slaveVisible" slot="vessel">
          <line-label slot="label" :class="elementDict.vessel.isRequire ? 'blue' : ''" :label="elementDict.vessel.label" />
          <cargo-input v-model="job.vessel" no="39" :disabled="readonly || !pm.lclMasterFlag || isCrossTenantSEToSI" :auto-uppercase="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.voyageFlight.slaveVisible" slot="voyageFlight">
          <line-label slot="label" :class="elementDict.voyageFlight.isRequire ? 'blue' : ''" :label="elementDict.voyageFlight.label" />
          <div style="display: flex;justify-content: space-between">
            <cargo-input v-model="job.voyageFlight" no="40" :disabled="readonly || !pm.lclMasterFlag || isCrossTenantSEToSI" style="flex: 1" :auto-uppercase="true" @focus="loadVoyageFlight" />
            <div style="margin-left:5px;"> <el-checkbox v-model="isTwoVessel" :disabled="readonly">{{ $t('SeaExport.SecondCheck') }}</el-checkbox></div>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.secondVessel.slaveVisible && isTwoVessel" slot="secondVessel">
          <line-label slot="label" :class="elementDict.secondVessel.isRequire ? 'blue' : ''" :label="elementDict.secondVessel.label" />
          <cargo-input v-model="job.secondVessel" no="41" :disabled="readonly" :auto-uppercase="isUppercase" />
        </el-form-item>
        <el-form-item v-if="elementDict.secondVoyage.slaveVisible && isTwoVessel" slot="secondVoyage">
          <line-label slot="label" :class="elementDict.secondVoyage.isRequire ? 'blue' : ''" :label="elementDict.secondVoyage.label" />
          <cargo-input v-model="job.secondVoyage" no="42" :disabled="readonly" :auto-uppercase="isUppercase" />
        </el-form-item>
        <el-form-item v-if="elementDict.dispatchingPlace.slaveVisible" slot="dispatchingPlace">
          <line-label slot="label" :class="elementDict.dispatchingPlace.isRequire ? 'blue' : ''" :label="elementDict.dispatchingPlace.label" />
          <cargo-input v-model="job.dispatchingPlace" no="43" :disabled="readonly" :auto-uppercase="isUppercase" />
        </el-form-item>
        <el-form-item v-show="elementDict.loadingPortCode.slaveVisible" slot="loadingPortCode">
          <line-label slot="label" :class="elementDict.loadingPortCode.isRequire ? 'blue' : ''" :label="elementDict.loadingPortCode.label" />
          <cargo-advance-select
            ref="loadingPortCode"
            no="44"
            filterable
            :disabled="readonly || isCrossTenantSEToSI"
            :placeholder="$t('SeaExport.RequiredItem')"
            :select-type="selectTypeNames.basic_data_Seaport"
            :default-value="job.loadingPortCode"
            tag-name="englishName"
            :method-params="{}"
            @parentCallBack="p=>{pm.changeLoadingPortCode(p);pm.checkVesselLine(); }"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dischargingPortCode.slaveVisible" slot="dischargingPortCode">
          <line-label slot="label" :class="elementDict.dischargingPortCode.isRequire ? 'blue' : ''" :label="elementDict.dischargingPortCode.label" />
          <cargo-advance-select
            no="45"
            filterable
            :disabled="readonly || isCrossTenantSEToSI"
            :placeholder="$t('SeaExport.RequiredItem')"
            :callback-params="{key:'dischargingPortCode'}"
            :select-type="selectTypeNames.basic_data_Seaport"
            :default-value="job.dischargingPortCode"
            tag-name="englishName"
            :method-params="{}"

            @parentCallBack="p=>{job.dischargingPortCode=p.value;pm.dischargingPortCodeChange(p.value);pm.changeDischargingPort2()}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.destinationPortCode.slaveVisible" slot="destinationPortCode">
          <line-label slot="label" :class="elementDict.destinationPortCode.isRequire ? 'blue' : ''" :label="elementDict.destinationPortCode.label" />
          <cargo-advance-select
            no="destinationPortCode"
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_Seaport"
            filterable
            :default-value="job.destinationPortCode"
            :placeholder="$t('SeaExport.RequiredItem')"
            @parentCallBack="p=>{job.destinationPortCode=p.value;pm.destinationPortCodeEasyChange(p);pm.changeDestinationPort()}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.destinationPlace.slaveVisible" slot="destinationPlace">
          <line-label slot="label" :class="elementDict.destinationPlace.isRequire ? 'blue' : ''" :label="elementDict.destinationPlace.label" />
          <cargo-input v-model="job.destinationPlace" no="46" :disabled="readonly" @change="pm.changeDestinationPort()" />
        </el-form-item>
        <el-form-item v-if="elementDict.vesselLine.slaveVisible" slot="vesselLine">
          <line-label slot="label" :class="elementDict.vesselLine.isRequire ? 'blue' : ''" :label="elementDict.vesselLine.label" />
          <el-input
            no="47"
            :value="job.loadingPortCode ? pm.vesselLine : ''"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customsDate.slaveVisible" slot="customsDate">
          <line-label slot="label" :class="elementDict.customsDate.isRequire ? 'blue' : ''" :label="elementDict.customsDate.label" />
          <el-date-picker
            v-model="job.customsDate"
            no="48"
            :disabled="readonly"
            clearable
            style="width:100%;"
            type="date"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.bookingDate.slaveVisible" slot="bookingDate">
          <line-label slot="label" :class="elementDict.bookingDate.isRequire ? 'blue' : ''" :label="elementDict.bookingDate.label" />
          <el-date-picker
            v-model="job.bookingDate"
            no="49"
            :disabled="readonly"
            type="date"
            style="width:100%;"
            clearable
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.etd.slaveVisible" slot="etd">
          <line-label slot="label" :class="elementDict.etd.isRequire ? 'blue' : ''" :label="elementDict.etd.label" />
          <div style="display: flex">
            <el-date-picker
              v-model="job.etd"
              no="50"
              :disabled="!controllerEnable.dfETD||!pm.lclMasterFlag||isCrossTenantSEToSI"
              :placeholder="elementDict.etd.isRequire ? $t('SeaExport.RequiredItem') : ''"
              type="date"
              style="flex: 1; width: 170px; margin-right: 5px"
              clearable
              value-format="yyyy-MM-dd"
              @input="etdChange"
            />
            <span>{{ job.sailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.eta.slaveVisible" slot="eta">
          <line-label slot="label" :class="elementDict.eta.isRequire ? 'blue' : ''" :label="elementDict.eta.label" />
          <div style="display: flex">
            <el-date-picker
              v-model="job.eta"
              no="51"
              :disabled="readonly || !pm.lclMasterFlag || provisionEtdLocked"
              :placeholder="$t('SeaExport.RequiredItem')"
              type="date"
              style="flex: 1;width: 170px; margin-right: 5px"
              clearable
              value-format="yyyy-MM-dd"
              @input="etaChange"
            />
            <span>{{ job.etaSailingDay|filterWeek }}</span>
          </div>
          <span v-if="provisionEtdLocked" style="color: red; font-size: 12px;">(已计提校准不可修改)</span>
        </el-form-item>
        <el-form-item v-if="elementDict.atd.slaveVisible" slot="atd">
          <line-label slot="label" :class="elementDict.atd.isRequire ? 'blue' : ''" :label="elementDict.atd.label" />
          <div style="display: flex">
            <el-date-picker
              v-model="job.atd"
              no="52"
              :disabled="readonly || !pm.lclMasterFlag"
              style="flex: 1;width: 170px; margin-right: 5px"
              type="date"
              value-format="yyyy-MM-dd"
              @input="atdChange"
            />
            <span>{{ job.atdSailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.ata.slaveVisible" slot="ata">
          <line-label slot="label" :class="elementDict.ata.isRequire ? 'blue' : ''" :label="elementDict.ata.label" />
          <div style="display: flex">
            <el-date-picker
              v-model="job.ata"
              no="53"
              :disabled="readonly || !pm.lclMasterFlag"
              style="flex: 1;width: 170px; margin-right: 5px"
              type="date"
              value-format="yyyy-MM-dd"
              @input="ataChange"
            />
            <span>{{ job.ataSailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.arrivalTime.slaveVisible" slot="arrivalTime">
          <line-label slot="label" :class="elementDict.arrivalTime.isRequire ? 'blue' : ''" :label="elementDict.arrivalTime.label" />
          <el-date-picker
            v-model="job.arrivalTime"
            no="123"
            :disabled="readonly"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customsBroker.slaveVisible" slot="customsBroker">
          <line-label slot="label" :class="elementDict.customsBroker.isRequire ? 'blue' : ''" :label="elementDict.customsBroker.label" />
          <cargo-advance-select
            no="54"
            :disabled="readonly || (isEdit && !job.customs) "
            :select-type="selectTypeNames.basic_data_Company"
            :data-filter-function="customsBrokerFilter"
            filterable
            :default-value="job.customsBroker||''"
            :placeholder="job.customs?'':$t('SeaExport.PleaseTickCustomsDeclarationOption')"
            :method-params="{customsBroker:true,companyLob:'seaImport',active:true}"
            @parentCallBack="p=>{customsBrokerChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customClaim.slaveVisible" slot="customClaim">
          <line-label slot="label" :class="elementDict.customClaim.isRequire ? 'blue' : ''" :label="elementDict.customClaim.label" />
          <cargo-advance-select
            no="customsMethod"
            :disabled="readonly || (isEdit && !job.customs)"
            :select-type="selectTypeNames.basic_data_CustomsMode"
            :method-params="{serviceType:2}"
            tag-value="serialNum"
            filterable
            :default-value="job.customClaim"
            @parentCallBack="p=>{job.customClaim=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customsDeclarationType.slaveVisible && job.customClaim===1" slot="customsDeclarationType">
          <line-label slot="label" :class="elementDict.customsDeclarationType.isRequire ? 'blue' : ''" :label="elementDict.customsDeclarationType.label" />
          <cargo-advance-select
            no="customsDeclarationType"
            :disabled="readonly || (isEdit && !job.customs)"
            :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
            filterable
            :default-value="job.customsDeclarationType===-1?'':job.customsDeclarationType"
            :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
            @parentCallBack="p=>{job.customsDeclarationType=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.tradeTerm.slaveVisible" slot="tradeTerm">
          <line-label slot="label" :class="elementDict.tradeTerm.isRequire ? 'blue' : ''" :label="elementDict.tradeTerm.label" />
          <cargo-advance-select
            no="55"
            :disabled="readonly"
            :clearable="false"
            :select-type="selectTypeNames.basic_data_TradeTerm"
            filterable
            :default-value="job.tradeTerm"
            @parentCallBack="p=>{job.tradeTerm=p.value}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.bookingTerm.slaveVisible" slot="bookingTerm">
          <line-label slot="label" :class="elementDict.bookingTerm.isRequire ? 'blue' : ''" :label="elementDict.bookingTerm.label" />
          <el-select
            ref="bookingTerm"
            v-model="job.bookingTerm"
            no="56"
            :disabled="readonly || isCrossTenantSEToSI"
            :placeholder="readonly ? '' : $t('SeaExport.PleaseSelect')"
            :clearable="false"
            size="mini"
            @change="pm.editInputVesselModel()"
          >
            <el-option
              v-for="(item,index) in bookingTerms"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.scNo.slaveVisible" slot="scNo">
          <line-label slot="label" :class="elementDict.scNo.isRequire ? 'blue' : ''" :label="elementDict.scNo.label" />
          <el-input v-model="job.scNo" no="57" :disabled="readonly" />
        </el-form-item>
        <el-form-item v-if="elementDict.freeDemurrage.slaveVisible" slot="freeDemurrage">
          <line-label slot="label" :class="elementDict.freeDemurrage.isRequire ? 'blue' : ''" :label="elementDict.freeDemurrage.label" />
          <auto-number-input
            v-model="job.freeDemurrage"
            :precision="0"
            :min="0"
            :disabled="readonly"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.freeDetention.slaveVisible" slot="freeDetention">
          <line-label slot="label" :class="elementDict.freeDetention.isRequire ? 'blue' : ''" :label="elementDict.freeDetention.label" />
          <auto-number-input
            v-model="job.freeDetention"
            no="58"
            :precision="0"
            :min="0"
            :disabled="readonly"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.terminalCompany.slaveVisible" slot="terminalCompany">
          <line-label slot="label" :class="elementDict.terminalCompany.isRequire ? 'blue' : ''" :label="elementDict.terminalCompany.label" />
          <cargo-company-select
            no="terminalCompany"
            :disabled="readonly"
            :method-params="{terminalCompany:true,companyLob:'seaImport',active:true}"
            :default-value="job.terminalCompany||''"
            style="width: 100%"
            @change="p=>{JobUtils.terminalCompanyChangeHandler(job, p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.deliveryAddress.slaveVisible" slot="deliveryAddress">
          <line-label slot="label" :class="elementDict.deliveryAddress.isRequire ? 'blue' : ''" :label="elementDict.deliveryAddress.label" />
          <cargo-rich-textarea
            v-model="job.deliveryAddress"
            no="deliveryAddress"
            :disabled="readonly"
            style="height: 110px;"
            @dblclick.native="showAdvanceTextDialog($t('Message.TerminalAddress'),job.deliveryAddress,val=>{job.deliveryAddress=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.transportSource.slaveVisible" slot="transportSource">
          <line-label slot="label" :class="elementDict.transportSource.isRequire ? 'blue' : ''" :label="elementDict.transportSource.label" />
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_TransportSource"
            no="transportSource"
            :default-value="job.transportSource"
            :cache="false"
            :disabled="readonly"
            tag-value="code"
            placeholder=" "
            @parentCallBack="item=>job.transportSource=item.value"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.statisticArea.slaveVisible" slot="statisticArea">
          <line-label slot="label" :class="elementDict.statisticArea.isRequire ? 'blue' : ''" :label="elementDict.statisticArea.label" />
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_StatisticArea"
            no="statisticArea"
            :default-value="job.statisticArea"
            :cache="false"
            :disabled="readonly"
            tag-value="code"
            placeholder=" "
            @parentCallBack="item=>job.statisticArea=item.value"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.deliverDate.slaveVisible" slot="deliverDate">
          <line-label slot="label" :class="elementDict.deliverDate.isRequire ? 'blue' : ''" :label="elementDict.deliverDate.label" />
          <el-date-picker
            v-model="job.deliverDate"
            no="59"
            style="width: 100%"
            :disabled="readonly"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
          />
        </el-form-item>
        <el-form-item v-if="elementDict.arriveStorageDate.slaveVisible" slot="arriveStorageDate">
          <line-label slot="label" :class="elementDict.arriveStorageDate.isRequire ? 'blue' : ''" :label="elementDict.arriveStorageDate.label" />
          <el-date-picker
            v-model="job.arriveStorageDate"
            no="60"
            style="width: 100%"
            :disabled="readonly"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
          />
        </el-form-item>
        <template v-if="elementDict.shipper.slaveVisible" slot="shipper">
          <el-form-item label="">
            <div style="display: flex;justify-content: flex-end">
              <el-button no="61" type="primary" :disabled="readonly" @click="pm.onExcerption()">{{ $t('SeaExport.CopyFromOtherBill') }}</el-button>
              <el-button no="62" type="primary" :disabled="readonly" @click="pm.onCodeSearch()">{{ $t('SeaExport.CodeSearching') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item>
            <template slot="label">
              <line-label :class="elementDict.shipper.isRequire ? 'blue' : ''" :label="elementDict.shipper.label" />
              <char-count :form="job" prefix="shipper" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div style="display: flex;justify-content: space-between">
              <cargo-input v-model="job.shipperCode" no="63" style="width:80px;margin-right: 5px" :disabled="readonly" :placeholder="readonly ? '' : $t('SeaExport.Code2')" :auto-uppercase="notUppercaseShipperConsigneNotify" />
              <cargo-company-select
                no="64"
                :disabled="readonly"
                :method-params="{shipper:true,active:true}"
                :default-value="job.shipperId||''"
                tag-name="englishName"
                style="flex: 1;margin-bottom: 10px"
                @change="data => {senderAndReceiverChange('shipper',data, 7)}"
              />
            </div>
            <cargo-input
              v-model="job.shipperLine1"
              no="65"
              :disabled="readonly"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :placeholder="readonly ? '' : $t('SeaExport.BillsOfLadingDoubleClickEject')"
              :use-read-only="true"
              @dblclick.native="showSenderAndReceiverDialog('shipper',7, false, notUppercaseShipperConsigneNotify);focusAdvanceTextInput()"
              @blur="pm.shipperAddrChangeFunc()"
            />
            <!--  处理弹框中值变更 不同步问题-->
            <cargo-input v-show="false" v-model="job.shipperLine2" no="shipperLine2" @change="pm.shipperAddrChangeFunc()" />
            <cargo-input v-show="false" v-model="job.shipperLine3" no="shipperLine3" @change="pm.shipperAddrChangeFunc()" />
            <cargo-input v-show="false" v-model="job.shipperLine4" no="shipperLine4" @change="pm.shipperAddrChangeFunc()" />
            <cargo-input v-show="false" v-model="job.shipperLine5" no="shipperLine5" @change="pm.shipperAddrChangeFunc()" />
            <cargo-input v-show="false" v-model="job.shipperLine6" no="shipperLine6" @change="pm.shipperAddrChangeFunc()" />
          </el-form-item>
        </template>
        <el-form-item v-if="elementDict.consignee.slaveVisible" slot="consignee">
          <template slot="label">
            <line-label :class="elementDict.consignee.isRequire ? 'blue' : ''" :label="elementDict.consignee.label" />
            <char-count :form="job" prefix="consignee" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <div style="display: flex;justify-content: space-between">
            <cargo-input
              v-model="job.consigneeCode"
              no="66"
              style="width:80px;margin-right: 5px"
              :disabled="readonly"
              :placeholder="readonly ? '' : $t('SeaExport.Code2')"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              @change="pm.qConsigneeCode_focusOutHandler()"
            />
            <cargo-company-select
              no="67"
              :disabled="readonly"
              :method-params="{consignee:true,active:true}"
              :default-value="job.consigneeId||''"
              tag-name="englishName"
              style="flex: 1;margin-bottom: 10px"
              @change="data => {senderAndReceiverChange('consignee',data, 7, true, notUppercaseShipperConsigneNotify)}"
            />
          </div>
          <cargo-input
            v-model="job.consigneeLine1"
            no="68"
            :disabled="readonly"
            :auto-uppercase="notUppercaseShipperConsigneNotify"
            :placeholder="readonly ? '' : $t('SeaExport.BillsOfLadingDoubleClickEject')"
            :use-read-only="true"
            @dblclick.native="showSenderAndReceiverDialog('consignee',7, false, notUppercaseShipperConsigneNotify);focusAdvanceTextInput()"
            @blur="pm.qConsigneeAddr_focusOutHandler(); pm.consigneeAddrChangeFunc()"
          />
          <!--  处理弹框中值变更 不同步问题-->
          <cargo-input v-show="false" v-model="job.consigneeLine2" no="consigneeLine2" @change="pm.consigneeAddrChangeFunc()" />
          <cargo-input v-show="false" v-model="job.consigneeLine3" no="consigneeLine3" @change="pm.consigneeAddrChangeFunc()" />
          <cargo-input v-show="false" v-model="job.consigneeLine4" no="consigneeLine4" @change="pm.consigneeAddrChangeFunc()" />
          <cargo-input v-show="false" v-model="job.consigneeLine5" no="consigneeLine5" @change="pm.consigneeAddrChangeFunc()" />
          <cargo-input v-show="false" v-model="job.consigneeLine6" no="consigneeLine6" @change="pm.consigneeAddrChangeFunc()" />
        </el-form-item>
        <el-form-item v-if="elementDict.notify.slaveVisible" slot="notify">
          <template slot="label">
            <line-label :class="elementDict.notify.isRequire ? 'blue' : ''" :label="elementDict.notify.label" />
            <char-count :form="job" prefix="notify" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <div style="display: flex;justify-content: space-between">
            <cargo-input v-model="job.notifyCode" no="69" style="width:80px;margin-right: 5px" :disabled="readonly" :placeholder="readonly ? '' : $t('SeaExport.Code2')" :auto-uppercase="notUppercaseShipperConsigneNotify" />
            <cargo-company-select
              no="70"
              :disabled="readonly"
              :method-params="{notify:true,active:true}"
              :default-value="job.notifyId||''"
              tag-name="englishName"
              style="flex: 1;margin-bottom: 10px"
              @change="data => {senderAndReceiverChange('notify',data, 7)}"
            />
          </div>
          <cargo-input
            v-model="job.notifyLine1"
            no="71"
            :disabled="readonly"
            :auto-uppercase="notUppercaseShipperConsigneNotify"
            :placeholder="readonly ? '' : $t('SeaExport.BillsOfLadingDoubleClickEject')"
            :use-read-only="true"
            @dblclick.native="showSenderAndReceiverDialog('notify',7,false, notUppercaseShipperConsigneNotify);focusAdvanceTextInput()"
            @blur="pm.notifyChangeFunc()"
          />
          <!--  处理弹框中值变更 不同步问题-->
          <cargo-input v-show="false" v-model="job.notifyLine2" no="notifyLine2" @change="pm.notifyChangeFunc()" />
          <cargo-input v-show="false" v-model="job.notifyLine3" no="notifyLine3" @change="pm.notifyChangeFunc()" />
          <cargo-input v-show="false" v-model="job.notifyLine4" no="notifyLine4" @change="pm.notifyChangeFunc()" />
          <cargo-input v-show="false" v-model="job.notifyLine5" no="notifyLine5" @change="pm.notifyChangeFunc()" />
          <cargo-input v-show="false" v-model="job.notifyLine6" no="notifyLine6" @change="pm.notifyChangeFunc()" />
        </el-form-item>
        <el-form-item v-if="elementDict.quantityActual.slaveVisible" slot="quantityActual">
          <line-label slot="label" :class="elementDict.quantityActual.isRequire ? 'blue' : ''" :label="elementDict.quantityActual.label" />
          <auto-number-input
            v-model="job.quantityActual"
            no="72"
            :precision="0"
            :min="0"
            :disabled="readonly || isCrossTenantSEToSI"
            @change="pm.quantityFocusInHandler()"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.packing.slaveVisible" slot="packing">
          <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
          <cargo-packing-select
            no="73"
            :disabled="readonly || isCrossTenantSEToSI"
            :default-value="job.packing"
            @change="p=>{job.packing=p.value;pm.chargePacking()}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.weightActual.slaveVisible" slot="weightActual">
          <line-label slot="label" :class="elementDict.weightActual.isRequire ? 'blue' : ''" :label="elementDict.weightActual.label" />
          <div style="display: flex">
            <auto-number-input
              v-model="job.weightActual"
              no="74"
              :precision="3"
              :min="0"
              :disabled="readonly || isCrossTenantSEToSI"
              @change="weightContractChange"
            />
            <span>KGS</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.cubageActual.slaveVisible" slot="cubageActual">
          <line-label slot="label" :class="elementDict.cubageActual.isRequire ? 'blue' : ''" :label="elementDict.cubageActual.label" />
          <div style="display: flex">
            <auto-number-input
              v-model="job.cubageActual"
              no="75"
              :precision="3"
              :min="0"
              :disabled="readonly || isCrossTenantSEToSI"
              @change="cubageContractChange"
            />
            <span>CBM</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.chargeWeight.slaveVisible" slot="chargeWeight">
          <line-label slot="label" :class="elementDict.chargeWeight.isRequire ? 'blue' : ''" :label="elementDict.chargeWeight.label" />
          <div style="display: flex">
            <auto-number-input
              v-model="job.chargeWeight"
              no="76"
              :precision="3"
              :min="0"
              :disabled="!controllerEnable.txtChargeWeight || isCrossTenantSEToSI"
              @change="pm.chargeWeightChangeHandler()"
            />
            <span>M/T</span>
          </div>
        </el-form-item>
        <el-form-item
          v-show="elementDict.seaEq.slaveVisible && job.containerLoadType!=='LCL'"
          slot="seaEq"
          label-width="0"
          class="auto-width"
        >
          <booking-sea-eq-data-grid
            v-if="job.containerLoadType!=='BULK' && job.containerLoadType!=='LCL'"
            :value="seaEqList"
            :container-load-type="job.containerLoadType"
            :is-edit="isEdit"
            :job="job"
            @eqQuantityChange="eqQuantityChangeHandler"
          />
          <booking-bulk-data-grid
            v-if="job.containerLoadType==='BULK'"
            :value="cargoBulkDetailList"
            :context="context"
            :show-excel-button="false"
            :job-uuid="job.uuid"
            :is-edit="isEdit"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.cargoEnglishName.slaveVisible" slot="cargoEnglishName">
          <line-label slot="label" :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
          <cargo-rich-textarea
            v-model="job.cargoEnglishName"
            :show-count="true"
            no="77"
            :disabled="readonly || isCrossTenantSEToSI"
            :text-chars="englishNameMaxChars"
            :warning-count="englishNameWarningCount"
            :auto-uppercase="isUppercaseByConfig"
            style="height: 110px;"
            @change="pm.txtCargoEnglishNameChangeHandler()"
            @dblclick.native="showAdvanceTextDialog($t('queryJob.englishDescriptionOfGoods'),job.cargoEnglishName,val=>{job.cargoEnglishName=val},false,null,isUppercaseByConfig , {
              warningCount: englishNameWarningCount,
              maxChar: englishNameMaxChars
            })"
          />

        </el-form-item>
        <el-form-item v-if="elementDict.cargoChineseName.slaveVisible" slot="cargoChineseName">
          <line-label slot="label" :class="elementDict.cargoChineseName.isRequire ? 'blue' : ''" :label="elementDict.cargoChineseName.label" />
          <cargo-rich-textarea
            v-model="job.cargoChineseName"
            :show-count="true"
            no="78"
            :disabled="readonly"
            :text-chars="maxChars"
            :warning-count="warningCount"
            :auto-half-word="false"
            style="height: 110px;"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),job.cargoChineseName,val=>{job.cargoChineseName=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.mark.slaveVisible" slot="mark">
          <line-label slot="label" :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
          <cargo-rich-textarea
            v-model="job.mark"
            :show-count="true"
            no="79"
            :disabled="readonly || isCrossTenantSEToSI"
            :text-chars="markMaxChars"
            :warning-count="markWarningCount"
            :auto-uppercase="isUppercaseByConfig"
            style="height: 110px;"
            @change="onMarkChange"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),job.mark,val=>{job.mark=val},false,null,isUppercaseByConfig , {
              warningCount: markWarningCount,
              maxChar: markMaxChars
            })"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.incoTerm.slaveVisible" slot="incoTerm">
          <line-label slot="label" :class="elementDict.incoTerm.isRequire ? 'blue' : ''" :label="elementDict.incoTerm.label" />
          <cargo-advance-select
            no="80"
            filterable
            :disabled="readonly || isCrossTenantSEToSI"
            :select-type="selectTypeNames.basic_data_IncoTerm"
            :method-params="{}"
            callback-method-type="value"
            :default-value="job.incoTerm+''"

            :callback-params="{key:'incoTerm'}"
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.depositReceived.slaveVisible" slot="depositReceived">
          <line-label slot="label" :class="elementDict.depositReceived.isRequire ? 'blue' : ''" :label="elementDict.depositReceived.label" />
          <div style="display: flex;justify-content: space-between">
            <el-input-number
              no="81"
              :value="job.depositReceived===0 ? undefined: job.depositReceived"
              style="flex-grow: 1"
              :disabled="readonly"
              :controls="false"
              :precision="3"
              @input="val=>{job.depositReceived=val}"
            />
            <span>{{ localCurrency }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.remarks.slaveVisible" slot="remarks">
          <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
          <cargo-rich-textarea
            v-model="job.remarks"
            no="82"
            :disabled="readonly || isCrossTenantSEToSI"
            :text-chars="maxChars"
            :warning-count="warningCount"
            :is-trim="true"
            style="height: 110px;"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),job.remarks,val=>{job.remarks=val})"
          />
        </el-form-item>
        <template v-if="elementDict.cargoCode.slaveVisible" slot="cargoCode">
          <el-form-item>
            <line-label slot="label" :class="elementDict.cargoCode.isRequire ? 'blue' : ''" :label="elementDict.cargoCode.label" />
            <cargo-advance-select
              no="83"
              :allow-create="false"
              :clearable="true"
              :default-value="job.cargoCode"
              :disabled="readonly"
              :select-type="selectTypeNames.basic_data_CargoInformation"
              filterable
              @parentCallBack="p=>{pm.cargoCodeChange(p.value)}"
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="job.cargoName"
              no="84"
              :disabled="!(isEdit && job.cargoCode!=='' && job.cargoCode!=null)"
            />
          </el-form-item>
        </template>
        <el-form-item v-if="elementDict.warehouseNo.slaveVisible" slot="warehouseNo">
          <line-label slot="label" :class="elementDict.warehouseNo.isRequire ? 'blue' : ''" :label="elementDict.warehouseNo.label" />
          <el-input v-model="job.warehouseNo" no="85" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.containerLoadType.slaveVisible" slot="containerLoadType">
          <line-label slot="label" :class="elementDict.containerLoadType.isRequire ? 'blue' : ''" :label="elementDict.containerLoadType.label" />
          <cargo-advance-select
            filterable
            no="86"
            :clearable="false"
            :disabled="!controllerEnable.qCargoType || isCrossTenantSEToSI"
            :select-type="selectTypeNames.local_cache_ImportConstants$_cargoTypeInputList"
            callback-method-type="value"
            :default-value="job.containerLoadType"
            :tag-name="$store.getters.language==='zh'?'chineseName':'englishName'"
            tag-value="code"
            :callback-params="{key:'containerLoadType'}"
            @parentCallBack="obj=>pm.qCargoType_Change(obj)"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.poNo.slaveVisible" slot="poNo" :class="poNoRed?'poNoClass':''">
          <line-label slot="label" :class="elementDict.poNo.isRequire ? 'blue' : ''" :label="elementDict.poNo.label" />
          <cargo-input v-if="!openProjectConfig" v-model="job.poNo" no="87" :disabled="readonly" :auto-uppercase="isUppercase" :use-read-only="true" />
          <cargo-project-select
            v-if="openProjectConfig"
            no="88"
            :disabled="readonly"
            :default-value="job.poNo"
            :customer-id="job.customerId"
            :is-linked="isProjectLinkedCustomer"
            @change="
              p => {
                job.poNo = p.value
                job.projectName = p.projectName
                pm.changeProject()
              }
            "
          />
        </el-form-item>
        <el-form-item
          v-if="elementDict.projectName.slaveVisible && openProjectConfig"
          slot="projectName"
          :label="$t('SeaExport.ProjectName')"
        >
          <line-label slot="label" :class="elementDict.projectName.isRequire ? 'blue' : ''" :label="elementDict.projectName.label" />
          <el-input v-model="job.projectName" no="89" :disabled="true" />
        </el-form-item>
        <el-form-item
          v-if="elementDict.projectBatch.slaveVisible && openProjectConfig"
          slot="projectBatch"
          :label="$t('SeaExport.ProjectBatch')"
        >
          <line-label slot="label" :class="elementDict.projectBatch.isRequire ? 'blue' : ''" :label="elementDict.projectBatch.label" />
          <el-input v-model="job.projectBatch" no="90" :disabled="readonly" />
        </el-form-item>
        <el-form-item v-show="elementDict.freightTermMBL.slaveVisible" slot="freightTermMBL">
          <line-label slot="label" :class="elementDict.freightTermMBL.isRequire ? 'blue' : ''" :label="elementDict.freightTermMBL.label" />
          <cargo-advance-select
            ref="freightTermMBL"
            no="91"
            filterable
            :clearable="false"
            :disabled="readonly || isCrossTenantSEToSI"
            :select-type="selectTypeNames.basic_data_ShippingTerm"
            :method-params="{}"
            callback-method-type="value"
            :default-value="job.freightTermMBL+''"

            :callback-params="{key:'freightTermMBL'}"
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.freightTermHBL.slaveVisible && !job.mblOnly" slot="freightTermHBL">
          <line-label slot="label" :class="elementDict.freightTermHBL.isRequire ? 'blue' : ''" :label="elementDict.freightTermHBL.label" />
          <cargo-advance-select
            no="92"
            filterable
            :clearable="false"
            :disabled="readonly || isCrossTenantSEToSI"
            :select-type="selectTypeNames.basic_data_ShippingTerm"
            :method-params="{}"
            callback-method-type="value"
            :default-value="job.freightTermHBL+''"
            :callback-params="{key:'freightTermHBL'}"
            @parentCallBack="obj=>pm.freightTermHBLChange(obj)"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.paymentTermMBL.slaveVisible" slot="paymentTermMBL">
          <line-label slot="label" :class="elementDict.paymentTermMBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermMBL.label" />
          <cargo-advance-select
            no="93"
            filterable
            :clearable="false"
            :disabled="readonly || !pm.lclMasterFlag || isCrossTenantSEToSI"
            :select-type="selectTypeNames.basic_data_PaymentTerm"
            :method-params="{}"
            callback-method-type="value"
            :default-value="job.paymentTermMBL+''"
            :callback-params="{key:'paymentTermMBL'}"
            @parentCallBack="obj=>pm.paymentTermMBLChange(obj)"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.mblPaymentPlaceBL.slaveVisible" slot="mblPaymentPlaceBL">
          <line-label slot="label" :class="elementDict.mblPaymentPlaceBL.isRequire ? 'blue' : ''" :label="elementDict.mblPaymentPlaceBL.label" />
          <el-input v-show="!isShowAcPaymentPlaceBL" v-model="mblDoc.paymentPlaceBL" no="94" :disabled="readonly" @change="pm.fieldChangeHandler();job.paymentPlaceMbl=mblDoc.paymentPlaceBL" />
        </el-form-item>
        <el-form-item v-show="elementDict.paymentTermHBL.slaveVisible && !job.mblOnly" slot="paymentTermHBL">
          <line-label slot="label" :class="elementDict.paymentTermHBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermHBL.label" />
          <cargo-advance-select
            filterable
            no="95"
            :clearable="false"
            :disabled="readonly || isCrossTenantSEToSI"
            :select-type="selectTypeNames.basic_data_PaymentTerm"
            :method-params="{}"
            callback-method-type="value"
            :default-value="job.paymentTermHBL+''"
            :callback-params="{key:'paymentTermHBL'}"
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.hblPaymentPlaceBL.slaveVisible && !job.mblOnly" slot="hblPaymentPlaceBL">
          <line-label slot="label" :class="elementDict.hblPaymentPlaceBL.isRequire ? 'blue' : ''" :label="elementDict.hblPaymentPlaceBL.label" />
          <el-input v-model="hdoc.paymentPlaceBL" no="96" :disabled="readonly" @change="job.paymentPlaceHbl=hdoc.paymentPlaceBL" />
        </el-form-item>
        <el-form-item v-if="elementDict.cargoType.slaveVisible" slot="cargoType">
          <line-label slot="label" :class="elementDict.cargoType.isRequire ? 'blue' : ''" :label="elementDict.cargoType.label" />
          <cargo-advance-select
            filterable
            no="97"
            :clearable="false"
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_CargoType"
            callback-method-type="value"
            :default-value="job.cargoType"
            :callback-params="{key:'cargoType'}"
            @parentCallBack="onCargoTypeChagne"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.releaseTypeHbl.slaveVisible && !job.mblOnly" slot="releaseTypeHbl">
          <line-label slot="label" :class="elementDict.releaseTypeHbl.isRequire ? 'blue' : ''" :label="elementDict.releaseTypeHbl.label" />
          <cargo-advance-select
            no="98"
            :disabled="readonly"
            :clearable="false"
            :select-type="selectTypeNames.local_cache_ImportConstants$_importReleaseTypes"
            callback-method-type="value"
            :default-value="job.releaseTypeHbl"
            :headers="[$t('Tool.Code')]"
            :fields="['code']"
            :tag-name="isZh?'chineseName':'englishName'"
            tag-value="code"

            :callback-params="{key:'releaseTypeHbl'}"
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.releaseTypeMbl.slaveVisible" slot="releaseTypeMbl">
          <line-label slot="label" :class="elementDict.releaseTypeMbl.isRequire ? 'blue' : ''" :label="elementDict.releaseTypeMbl.label" />
          <cargo-advance-select
            no="99"
            :disabled="readonly || !pm.lclMasterFlag"
            :clearable="false"
            :select-type="selectTypeNames.local_cache_ImportConstants$_importReleaseTypes"
            callback-method-type="value"
            :default-value="job.releaseTypeMbl"
            :headers="[$t('Tool.Code')]"
            :fields="['code']"
            :tag-name="isZh?'chineseName':'englishName'"
            tag-value="code"
            :callback-params="{key:'releaseTypeMbl'}"
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.portDistrict.slaveVisible" slot="portDistrict">
          <line-label slot="label" :class="elementDict.portDistrict.isRequire ? 'blue' : ''" :label="elementDict.portDistrict.label" />
          <cargo-input v-model="job.portDistrict" no="100" :disabled="readonly" :auto-uppercase="isUppercase" />
        </el-form-item>
        <el-form-item v-if="elementDict.vesselUnCode.slaveVisible" slot="vesselUnCode">
          <line-label slot="label" :class="elementDict.vesselUnCode.isRequire ? 'blue' : ''" :label="elementDict.vesselUnCode.label" />
          <cargo-input v-model="job.vesselUnCode" no="101" :disabled="readonly" :auto-uppercase="isUppercase" />
        </el-form-item>
        <el-form-item v-if="elementDict.transDate.slaveVisible" slot="transDate">
          <line-label slot="label" :class="elementDict.transDate.isRequire ? 'blue' : ''" :label="elementDict.transDate.label" />
          <el-date-picker
            v-model="job.transDate"
            no="102"
            :disabled="readonly"
            type="date"
            value-format="yyyy-MM-dd"
            style="width:100%;"
            clearable
            @change="pm.dfCustDate_focusOutHandler()"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.warehouseCmp.slaveVisible" slot="warehouseCmp">
          <line-label slot="label" :class="elementDict.warehouseCmp.isRequire ? 'blue' : ''" :label="elementDict.warehouseCmp.label" />
          <cargo-company-select
            no="103"
            :disabled="readonly || (isEdit && !job.warehousing) "
            :method-params="{warehouse:true,active:true}"
            :default-value="job.warehouseCmp||''"
            :placeholder="job.warehousing?'':$t('SeaExport.PleaseCheckWarehouses')"
            @change="p=>{pm.warehouseCmpChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.warehouseName.slaveVisible && openWarehouse" slot="warehouseName">
          <line-label slot="label" :class="elementDict.warehouseName.isRequire ? 'blue' : ''" :label="elementDict.warehouseName.label" />
          <el-select
            v-model="job.warehouseName"
            no="warehouseName"
            :disabled="readonly || (isEdit && !job.warehousing) || !job.warehouseCmp"
            :allow-create="true"
            filterable
            :clearable="true"
            @change="warehouseNameChangeHandler"
          >
            <el-option
              v-for="(item,index) in warehouseNameList"
              :key="index"
              :label="item.warehouseName"
              :value="item.warehouseName"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.txtSalesOffice.slaveVisible" slot="txtSalesOffice">
          <line-label slot="label" :class="elementDict.txtSalesOffice.isRequire ? 'blue' : ''" :label="elementDict.txtSalesOffice.label" />
          <el-input v-model="txtSalesOffice" no="104" :disabled="true" :placeholder="$t('SeaExport.RequiredItem')" />
        </el-form-item>
        <el-form-item v-show="elementDict.sales.slaveVisible" slot="sales">
          <line-label slot="label" :class="elementDict.sales.isRequire ? 'blue' : ''" :label="elementDict.sales.label" />
          <div style="display: flex;justify-content: space-between">
            <cargo-user-select
              ref="sales"
              no="105"
              :disabled="!saleEnabled"
              :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
              :default-value="job.sales||''"
              :static-options="salesList"
              :placeholder="salesPrompt"
              @change="p=>{pm.salesChangeHandler(p)}"
            />
            <el-checkbox v-model="job.provisioned" :disabled="true" style="margin-left: 5px">{{ $t('SeaExport.Accrued') }}</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.cargoSalesId.slaveVisible" slot="cargoSalesId">
          <line-label slot="label" :class="elementDict.cargoSalesId.isRequire ? 'blue' : ''" :label="elementDict.cargoSalesId.label" />
          <cargo-user-select
            no="106"
            :disabled="readonly"
            :method-params="{category:'role',shape:'salesOfGoods'}"
            :default-value="job.cargoSalesId||''"
            :static-options="cargoSalesList"
            @change="p=>{job.cargoSalesId=p.value;pm.cargoSalesChargeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.salesDepartment.slaveVisible" slot="salesDepartment">
          <line-label slot="label" :class="elementDict.salesDepartment.isRequire ? 'blue' : ''" :label="elementDict.salesDepartment.label" />
          <cargo-department-new-select
            no="107"
            :disabled="readonly || (isEdit && (job.sales=== 0 || !job.sales))"
            :sales-id="Number(job.sales)"
            :office-id="job.salesOffice"
            :department-id="Number(job.salesDepartment)"
            :enables="true"
            @change="p=>{job.salesDepartment=p.value;pm.departmentChargeHandler()}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.opOffice.slaveVisible" slot="opOffice">
          <line-label slot="label" :class="elementDict.opOffice.isRequire ? 'blue' : ''" :label="elementDict.opOffice.label" />
          <cargo-advance-select
            no="108"
            :disabled="readonly || opOfficeDisabled"
            :select-type="selectTypeNames.basic_data_Office"
            filterable
            :default-value="job.opOffice"
            :static-options="cacheOffices || allCacheOffices"
            placeholder=""
            @parentCallBack="opOfficeChangeHandler"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.opDepartment.slaveVisible" slot="opDepartment">
          <line-label slot="label" :class="elementDict.opDepartment.isRequire ? 'blue' : ''" :label="elementDict.opDepartment.label" />
          <cargo-department-select
            ref="department"
            no="109"
            :disabled="!saleEnabled"
            :office-id="Number(job.opOffice)"
            :enables="true"
            :department-id="Number(job.opDepartment)"
            @change="p=>{job.opDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.op.slaveVisible" slot="op">
          <line-label slot="label" :class="elementDict.op.isRequire ? 'blue' : ''" :label="elementDict.op.label" />
          <cargo-user-select
            :disabled="readonly"
            no="110"
            :method-params="{officeId:job.opOffice,category:'role',shape:'siop'}"
            :default-value="job.op||''"
            :static-options="userPortRoleData.op"
            @change="p=>{job.op=p.value;pm.opChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.csrOffice.slaveVisible" slot="csrOffice">
          <line-label slot="label" :class="elementDict.csrOffice.isRequire ? 'blue' : ''" :label="elementDict.csrOffice.label" />
          <cargo-office-select
            no="csrOffice"
            :disabled="true"
            :office-id="Number(job.csrOffice)"
            @change="p=>{job.csrOffice=p.value;job.csrDepartment=0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.csrDepartment.slaveVisible" slot="csrDepartment">
          <line-label slot="label" :class="elementDict.csrDepartment.isRequire ? 'blue' : ''" :label="elementDict.csrDepartment.label" />
          <cargo-department-select
            no="csrDepartment"
            :office-id="Number(job.csrOffice)"
            :enables="true"
            :disabled="readonly"
            :department-id="Number(job.csrDepartment)"
            @change="p=>{job.csrDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.csr.slaveVisible" slot="csr">
          <line-label slot="label" :class="elementDict.csr.isRequire ? 'blue' : ''" :label="elementDict.csr.label" />
          <cargo-user-select
            ref="csr"
            no="111"
            :disabled="readonly"
            :method-params="{category:'role',shape:'csr'}"
            :default-value="job.csr||''"
            :static-options="userPortRoleData.csr"
            @change="p=>{pm.csrChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dcOffice.slaveVisible" slot="dcOffice">
          <line-label slot="label" :class="elementDict.dcOffice.isRequire ? 'blue' : ''" :label="elementDict.dcOffice.label" />
          <cargo-office-select
            no="dcOffice"
            :disabled="true"
            :office-id="Number(job.dcOffice)"
            @change="p=>{job.dcOffice=p.value;job.dcDepartment=0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dcDepartment.slaveVisible" slot="dcDepartment">
          <line-label slot="label" :class="elementDict.dcDepartment.isRequire ? 'blue' : ''" :label="elementDict.dcDepartment.label" />
          <cargo-department-select
            no="dcDepartment"
            :office-id="Number(job.dcOffice)"
            :enables="true"
            :disabled="readonly"
            :department-id="Number(job.dcDepartment)"
            @change="p=>{job.dcDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.dc.slaveVisible" slot="dc">
          <line-label slot="label" :class="elementDict.dc.isRequire ? 'blue' : ''" :label="elementDict.dc.label" />
          <cargo-user-select
            ref="dc"
            no="112"
            :disabled="readonly"
            :method-params="{category:'role',shape:'doc'}"
            :default-value="job.dc||''"
            :static-options="userPortRoleData.doc"
            @change="p=>{pm.dcChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.plannerOffice && elementDict.plannerOffice.slaveVisible" slot="plannerOffice">
          <line-label slot="label" :class="elementDict.plannerOffice.isRequire ? 'blue' : ''" :label="elementDict.plannerOffice.label" />
          <cargo-office-select
            no="plannerOffice"
            :disabled="true"
            :office-id="Number(job.plannerOffice)"
            @change="p=>{job.plannerOffice=p.value;job.plannerDepartment=0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.plannerDepartment && elementDict.plannerDepartment.slaveVisible" slot="plannerDepartment">
          <line-label slot="label" :class="elementDict.plannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.plannerDepartment.label" />
          <cargo-department-select
            no="plannerDepartment"
            :office-id="Number(job.plannerOffice)"
            :enables="true"
            :disabled="readonly"
            :department-id="Number(job.plannerDepartment)"
            @change="p=>{job.plannerDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.planner.slaveVisible" slot="planner">
          <line-label slot="label" :class="elementDict.planner.isRequire ? 'blue' : ''" :label="elementDict.planner.label" />
          <cargo-user-select
            no="113"
            :disabled="readonly"
            :method-params="{category:'role',shape:'seaLine'}"
            :default-value="job.planner||''"
            :static-options="userPortRoleData.seaLine"
            @change="p=>{job.planner=p.value;pm.txtPlannerChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.loadingPortOp.slaveVisible" slot="loadingPortOp">
          <line-label slot="label" :class="elementDict.loadingPortOp.isRequire ? 'blue' : ''" :label="elementDict.loadingPortOp.label" />
          <cargo-user-select
            no="114"
            :disabled="readonly"
            :method-params="{category:'role',shape:'siop'}"
            :default-value="job.loadingPortOp||''"
            @change="p=>{job.loadingPortOp=p.value;}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.destinationPortOp.slaveVisible" slot="destinationPortOp">
          <line-label slot="label" :class="elementDict.destinationPortOp.isRequire ? 'blue' : ''" :label="elementDict.destinationPortOp.label" />
          <cargo-user-select
            no="115"
            :disabled="readonly"
            :method-params="{category:'role',shape:'siop'}"
            :default-value="job.destinationPortOp||''"
            @change="p=>{job.destinationPortOp=p.value;}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.siteOP.slaveVisible" slot="siteOP">
          <line-label slot="label" :class="elementDict.siteOP.isRequire ? 'blue' : ''" :label="elementDict.siteOP.label" />
          <cargo-user-select
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'siteOp'}"
            :default-value="job.siteOP||''"
            :static-options="userPortRoleData.siteOp"
            @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.overseaOp.slaveVisible" slot="overseaOp">
          <line-label slot="label" :class="elementDict.overseaOp.isRequire ? 'blue' : ''" :label="elementDict.overseaOp.label" />
          <cargo-user-select
            ref="overseaOp"
            no="overseaOp"
            :disabled="readonly"
            class="input2"
            :default-value="job.overseaOp||''"
            :method-params="{category:'role',shape:'overseaOp'}"
            :static-options="isHC ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
            :merge-load="true"
            @change="p=>{
              job.overseaOp = p.value
              OverseaCustomerUtils.overseaOpChangeHandler(view, p)
            }"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.userDefinedRoleId1.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId1">
          <line-label slot="label" :class="elementDict.userDefinedRoleId1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId1.label" />
          <cargo-user-select
            ref="userDefinedRoleId1"
            no="userDefinedRoleId1"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
            :default-value="job.userDefinedRoleId1||''"
            :merge-load="true"
            :static-options="userPortRoleData.userDefinedRole1"
            @change="p=>{pm.userDefinedRoleId1Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.userDefinedRoleId2.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId2">
          <line-label slot="label" :class="elementDict.userDefinedRoleId2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId2.label" />
          <cargo-user-select
            ref="userDefinedRoleId2"
            no="userDefinedRoleId2"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
            :default-value="job.userDefinedRoleId2||''"
            :merge-load="true"
            :static-options="userPortRoleData.userDefinedRole2"
            @change="p=>{pm.userDefinedRoleId2Handler(p)}"
          />
        </el-form-item>
        <!-- <div v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.slaveVisible && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId3">
          <micro-app
            name="child-user-defined-role-si-userDefinedRoleId3"
            :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
            router-mode="pure"
            destroy
            @datachange="userDefinedRoleDataChangeUI"
          />
        </div>
        <div v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.slaveVisible && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId4">
          <micro-app
            name="child-user-defined-role-si-userDefinedRoleId4"
            :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
            router-mode="pure"
            destroy
            @datachange="userDefinedRoleDataChangeUI"
          />
        </div> -->
        <el-form-item v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId3">
          <line-label slot="label" :class="elementDict.userDefinedRoleId3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId3.label" />
          <cargo-user-select
            ref="userDefinedRoleId3"
            no="userDefinedRoleId3"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole3'}"
            :default-value="job.userDefinedRoleId3||''"
            :merge-load="true"
            :static-options="userPortRoleData.userDefinedRole3"
            @change="p=>{pm.userDefinedRoleId3Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId4">
          <line-label slot="label" :class="elementDict.userDefinedRoleId4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId4.label" />
          <cargo-user-select
            ref="userDefinedRoleId4"
            no="userDefinedRoleId4"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole4'}"
            :default-value="job.userDefinedRoleId4||''"
            :merge-load="true"
            :static-options="userPortRoleData.userDefinedRole4"
            @change="p=>{pm.userDefinedRoleId4Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId5 && elementDict.userDefinedRoleId5.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId5">
          <line-label slot="label" :class="elementDict.userDefinedRoleId5.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId5.label" />
          <cargo-user-select
            ref="userDefinedRoleId5"
            no="userDefinedRoleId5"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole5'}"
            :default-value="job.userDefinedRoleId5||''"
            :disabled="readonly"
            :merge-load="true"
            @change="p=>{pm.userDefinedRoleId5Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId6 && elementDict.userDefinedRoleId6.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId6">
          <line-label slot="label" :class="elementDict.userDefinedRoleId6.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId6.label" />
          <cargo-user-select
            ref="userDefinedRoleId6"
            no="userDefinedRoleId6"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole6'}"
            :default-value="job.userDefinedRoleId6||''"
            :disabled="readonly"
            :merge-load="true"
            @change="p=>{pm.userDefinedRoleId6Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId7 && elementDict.userDefinedRoleId7.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId7">
          <line-label slot="label" :class="elementDict.userDefinedRoleId7.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId7.label" />
          <cargo-user-select
            ref="userDefinedRoleId7"
            no="userDefinedRoleId7"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole7'}"
            :default-value="job.userDefinedRoleId7||''"
            :disabled="readonly"
            :merge-load="true"
            @change="p=>{pm.userDefinedRoleId7Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId8 && elementDict.userDefinedRoleId8.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId8">
          <line-label slot="label" :class="elementDict.userDefinedRoleId8.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId8.label" />
          <cargo-user-select
            ref="userDefinedRoleId8"
            no="userDefinedRoleId8"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole8'}"
            :default-multiple-value="toNumArray(job.userDefinedRoleId8)"
            :disabled="readonly"
            :multiple="true"
            :merge-load="true"
            :placeholder="readonly ? ' ' : ''"
            @change="p=>{job.userDefinedRoleId8=toTxt(p.value)}"
          />
        </el-form-item>
        <div v-show="elementDict.satisfiedRequests.slaveVisible" slot="satisfiedRequests">
          <special-requests-grid
            ref="selectedSpecialRequest"
            v-model="job.satisfiedRequests"
            no="116"
            :customer-id="Number(job.customerId)"
            :lob="job.lob"
            :job="job"
            :is-edit="isEdit"
          />
        </div>
        <el-form-item v-if="elementDict.userDefinedField1.slaveVisible" slot="userDefinedField1">
          <line-label slot="label" :class="elementDict.userDefinedField1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField1.label" />
          <el-input
            v-model="job.userDefinedField1"
            no="117"
            :disabled="readonly"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField1'),job.userDefinedField1,val=>{job.userDefinedField1=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField2.slaveVisible" slot="userDefinedField2">
          <line-label slot="label" :class="elementDict.userDefinedField2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField2.label" />
          <el-input
            v-model="job.userDefinedField2"
            no="118"
            :disabled="readonly"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField2'),job.userDefinedField2,val=>{job.userDefinedField2=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField3.slaveVisible" slot="userDefinedField3">
          <line-label slot="label" :class="elementDict.userDefinedField3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField3.label" />
          <el-input
            v-model="job.userDefinedField3"
            no="119"
            :disabled="readonly"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField3'),job.userDefinedField3,val=>{job.userDefinedField3=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField4.slaveVisible" slot="userDefinedField4">
          <line-label slot="label" :class="elementDict.userDefinedField4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField4.label" />
          <el-input
            v-model="job.userDefinedField4"
            no="120"
            :disabled="readonly"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField4'),job.userDefinedField4,val=>{job.userDefinedField4=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.taxNature && elementDict.taxNature.slaveVisible" slot="taxNature">
          <line-label slot="label" :class="elementDict.taxNature.isRequire ? 'blue' : ''" :label="elementDict.taxNature.label" />
          <el-select
            v-model="job.taxNature"
            :disabled="readonly"
            no="taxNature"
            :placeholder="$t('SeaExport.PleaseSelect')"
            size="mini"
          >
            <el-option
              v-for="(item,index) in TAX_NATURES"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>&nbsp;
        </el-form-item>
        <el-form-item v-if="elementDict.rateType && elementDict.rateType.slaveVisible" slot="rateType">
          <line-label slot="label" :class="elementDict.rateType.isRequire ? 'blue' : ''" :label="elementDict.rateType.label" />
          <el-select
            v-model="job.rateType"
            :disabled="readonly"
            no="rateType"
            clearable
            :placeholder="$t('SeaExport.PleaseSelect')"
            size="mini"
          >
            <el-option
              v-for="(item,index) in rateType"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>&nbsp;
        </el-form-item>
      </basic-tab-UICustom-layout>
    </div>
    <cargo-contacts-info-dialog
      v-if="showContactsInfoDialog"
      :visible.sync="showContactsInfoDialog"
      :customer-id="job.customerId"
      :customer-contact="job.customerContact"
    />
    <sop-dialog
      :visible.sync="sopDialog.visible"
      :cmp-idx="sopDialog.cmpIdx"
      :job="job"
      :agent="sopDialog.agent"
      lob="SI"
      :contact-list="sopDialog.contactList"
      @updateJob="$emit('updateJob')"
    />

    <!-- 高级文本弹框 -->
    <el-dialog
      ref="advanceTextDialog"
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :disabled="readonly"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="!readonly" no="121" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="122"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>

    <!--  单号抄录-->
    <import-prompt-title-dialog
      :visible.sync="importPromptTitleDialog.visible"
      :lob="job.lob"
      @selected="p=>{pm.onExcerptionChangeFunc(p)}"
    />

    <!--  代码检索-->
    <import-bill-address-title-dialog :visible.sync="billAddressDialog.visible" :job="job" @callback="p=>{pm.codeSearchCallback(p)}" />

    <!-- 订舱章弹窗 -->
    <stamp-picture-view
      :visible.sync="stampPictureView.visible"
      :business-documents="stampPictureView.businessDocuments"
    />
  </div>
</template>

<script>
import { TabError } from '@/utils/class/TabError'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import basicTabUICustomLayout from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/basicTabUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import basicTab from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/basicTab.vue'
import StrUtils from '@/utils/StrUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import microApp from '@micro-zoe/micro-app'
import { toNumArray, toTxt } from '@/utils/commonUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'BasicTabUICustom',
  components: { basicTabUICustomLayout },
  extends: basicTab,
  props: {
    previewConfig: { type: Object, default: null },
    provisionLock: {
      type: Object,
      default: () => ({ etdLocked: false, feeLocked: false })
    }
  },
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null, // 用于调用父级的方法
      userDefinedRoleDataUI: { // 子应用自定义岗位
        filedLable: 'CargoMsg.Cargo_userDefinedRole3',
        labelWidth: '133px',
        labelPosition: 'right',
        no: 'userDefinedRoleId3',
        fieldData: this.job ? this.job.userDefinedRoleId3 : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: '',
        officeId: null,
        category: 'role',
        shape: 'userDefinedRole3',
        staticOptions: null,
        mergeLoad: true
      },
      scacList: [],
      carrierScacEdit: false
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    toTxt,
    toNumArray,
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
      this.scacList = await JobUtils.getScacList(this.job.carrierScac)
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.SI_BOOKING_BASIC, this.$store.getters.currentOfficeId)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
      this.carrierScacEdit = JobUtils.checkCarrierScacEdit(this.elementDict)
    },
    async validateForm() {
      const form = this.job
      for (const key in this.fieldDict) {
        const field = this.fieldDict[key]
        if (field.slaveVisible && field.isRequire) {
          if (key === 'secondaryCustomJobType') {
            if (!(this.job.customJobType && this.secondaryCustomJobTypeList.length > 0)) {
              continue
            }
          }
          if (key === 'projectName' || key === 'projectBatch') {
            if (!this.openProjectConfig) {
              continue
            }
          }
          if (key === 'userDefinedRoleId1' || key === 'userDefinedRoleId2') {
            if (!this.isAddUserDefinedRoles) {
              continue
            }
          }
          if (key === 'mbl' || key === 'vessel' || key === 'voyageFlight' || key === 'paymentTermMBL') {
            if (!this.pm.lclMasterFlag || this.isCrossTenantSEToSI) {
              continue
            }
          }
          if (key === 'atd' || key === 'ata') {
            if (!this.pm.lclMasterFlag) {
              continue
            }
          }
          if (key.startsWith('shipper') || key.startsWith('consignee') || key.startsWith('notify')) {
            continue
          }
          if (key === 'designationAgent') {
            if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && !form.designationAgent) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'basicTab')
            }
          } else if (key === 'customClaim') {
            if (this.job.customs) {
              if (!ColumnUtils.customClaimLabelFunc(form.customClaim)) {
                throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.customClaim.label]), 'basicTab')
              }
            }
          } else if (key === 'customsBroker') {
            if (this.job.customs) {
              if (StrUtils.isEmpty(form[key])) {
                throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'basicTab')
              }
            }
          } else if (key === 'customsDeclarationType') {
            if (this.job.customClaim === 1 && this.job.customs) {
              if (form.customsDeclarationType === -1 || !ColumnUtils.customClaim2LabelFunc(form.customsDeclarationType)) {
                throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.customsDeclarationType.label]), 'basicTab')
              }
            }
          } else if (key === 'releaseTypeMbl' || key === 'releaseTypeHbl') {
            const label = ColumnUtils.releaseTypeLabelFunc(form[key])
            if (!label) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'basicTab')
            }
          } else if (key === 'taxNature') {
            if (form[key] === '' || form[key] === null) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else {
            if (typeof form[key] !== 'boolean' && StrUtils.isEmpty(form[key])) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'basicTab')
            }
          }
        }
      }
      if (this.elementDict.shipper.slaveVisible && this.elementDict.shipper.isRequire) {
        let shipperLine = ''
        for (let i = 1; i <= 7; ++i) {
          shipperLine += form['shipperLine' + i]
        }
        if (StrUtils.isEmpty(shipperLine) || StrUtils.isEmpty(form.shipperCode)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.shipper.label]), 'basicTab')
        }
      }
      if (this.elementDict.consignee.slaveVisible && this.elementDict.consignee.isRequire) {
        let consigneeLine = ''
        for (let i = 1; i <= 7; ++i) {
          consigneeLine += form['consigneeLine' + i]
        }
        if (StrUtils.isEmpty(consigneeLine) || StrUtils.isEmpty(form.consigneeCode)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.consignee.label]), 'basicTab')
        }
      }
      if (this.elementDict.notify.slaveVisible && this.elementDict.notify.isRequire) {
        let notifyLine = ''
        for (let i = 1; i <= 7; ++i) {
          notifyLine += form['notifyLine' + i]
        }
        if (StrUtils.isEmpty(notifyLine) || StrUtils.isEmpty(form.notifyCode)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.notify.label]), 'basicTab')
        }
      }
      if (this.elementDict.seaEq && this.elementDict.seaEq.slaveVisible && form.containerLoadType !== 'LCL' && this.elementDict.seaEq.isRequire) {
        if (form.containerLoadType === 'BULK') {
          if (!this.cargoBulkDetailList || this.cargoBulkDetailList.length === 0) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.seaEq.label]), 'basicTab')
          }
          for (const bulk of this.cargoBulkDetailList) {
            if (!bulk.insideQuantity) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.Pieces')]), 'basicTab')
            }
            if (!bulk.sizeLength || !bulk.sizeWidth || !bulk.sizeHeight) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.Dimension')]), 'basicTab')
            }
            if (!bulk.cubage) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.Cubage2')]), 'basicTab')
            }
            if (!bulk.weight) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.Weight2')]), 'basicTab')
            }
          }
        } else {
          if (!this.seaEqList || this.seaEqList.length === 0) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.seaEq.label]), 'basicTab')
          }
          for (const seaEq of this.seaEqList) {
            if (!seaEq.eqQuantity) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.ContainerAmount')]), 'basicTab')
            }
          }
        }
      }
      if (this.elementDict.warehouseCmp && this.elementDict.warehouseCmp.slaveVisible && this.elementDict.warehouseCmp.isRequire) {
        if (!form.warehouseCmp) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.warehouseCmp.label]), 'basicTab')
        }
      }
      if (this.elementDict.mblPaymentPlaceBL && this.elementDict.mblPaymentPlaceBL.slaveVisible && this.elementDict.mblPaymentPlaceBL.isRequire) {
        if (!this.mblDoc.paymentPlaceBL) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.mblPaymentPlaceBL.label]), 'basicTab')
        }
      }
      if (this.elementDict.hblPaymentPlaceBL && this.elementDict.hblPaymentPlaceBL.slaveVisible && this.elementDict.hblPaymentPlaceBL.isRequire) {
        if (!this.hdoc.paymentPlaceBL) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.hblPaymentPlaceBL.label]), 'basicTab')
        }
      }
      if (this.elementDict.cargoCode && this.elementDict.cargoCode.slaveVisible && this.elementDict.cargoCode.isRequire) {
        if (StrUtils.isEmpty(form.cargoCode) || StrUtils.isEmpty(form.cargoName)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.cargoCode.label]), 'basicTab')
        }
      }
      if (this.elementDict.paymentTermHBL && this.elementDict.paymentTermHBL.slaveVisible && this.elementDict.paymentTermHBL.isRequire) {
        if (StrUtils.isEmpty(form.paymentTermHBL)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.paymentTermHBL.label]), 'basicTab')
        }
      }
      this.superFunction = this.$options.extends.methods.validateForm
      return await this.superFunction()
    },
    setUserDefinedRoleDataUI() {
      return
      // userDefinedRoleId3
      const userDefinedRoleData3 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData3.fieldData = this.job.userDefinedRoleId3 || ''
      userDefinedRoleData3.disabled = this.readonly
      userDefinedRoleData3.filedLable = 'CargoMsg.Cargo_userDefinedRole3'
      userDefinedRoleData3.no = 'userDefinedRoleId3'
      userDefinedRoleData3.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData3.category = 'role'
      userDefinedRoleData3.shape = 'userDefinedRole3'
      userDefinedRoleData3.staticOptions = this.userPortRoleData.userDefinedRole3
      userDefinedRoleData3.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData3)
      microApp.forceSetData('child-user-defined-role-si-userDefinedRoleId3', userDefinedRoleData3)
      // userDefinedRoleId4
      const userDefinedRoleData4 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData4.fieldData = this.job.userDefinedRoleId4 || ''
      userDefinedRoleData4.disabled = this.readonly
      userDefinedRoleData4.filedLable = 'CargoMsg.Cargo_userDefinedRole4'
      userDefinedRoleData4.no = 'userDefinedRoleId4'
      userDefinedRoleData4.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData4.category = 'role'
      userDefinedRoleData4.shape = 'userDefinedRole4'
      userDefinedRoleData4.staticOptions = this.userPortRoleData.userDefinedRole4
      userDefinedRoleData4.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData4)
      microApp.forceSetData('child-user-defined-role-si-userDefinedRoleId4', userDefinedRoleData4)
    },
    userDefinedRoleDataChangeUI(e) {
      console.log('主应用获取UserDefinedRole:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setUserDefinedRoleDataUI()
        } else {
          if (e.detail.data.no === 'userDefinedRoleId3') {
            this.job.userDefinedRoleId3 = e.detail.data.fieldData
            this.pm.userDefinedRoleId3Handler(this.job.userDefinedRoleId3)
          } else if (e.detail.data.no === 'userDefinedRoleId4') {
            this.job.userDefinedRoleId4 = e.detail.data.fieldData
            this.pm.userDefinedRoleId4Handler(this.job.userDefinedRoleId4)
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
#app .section.form-column {
  width: auto;
}
  .el-form-item-group fieldset{
    min-height: 750px;
    width: 350px;
  }
  .checkbox {
    margin-right: 10px
  }
</style>

<!-- 中文样式 -->
<style scoped lang="scss">
#app.zh {
  .section::v-deep {
    &.down-two {
      width: 400px;
    }
  }
}
</style>

<!-- 英文样式 -->
<style scoped lang="scss">
#app.en {
  .section::v-deep {
    &.down-first {
      min-width: 420px;
    }
    &.down-two {
      width: 442px;
    }
    &.down-three {
      min-width: 364px;
    }
    &.down-four {
      width: 310px;
    }
  }
}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
</style>
